module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-180x180-fc93e04b23fa3425d8f5ce189790e1e6.png";